import { render } from "./loginView.vue?vue&type=template&id=19c54c7b"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__